import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HexCard from "../components/HexCard";
import { api } from "../lib/api";
import { RELEASES_PLACEHOLDER } from "../lib/assets";
import { resolveUploadUrl } from "../components/ImageUploadField";

export default function ReleasesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/releases")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-24"
      data-testid="releases-page"
    >
      <header className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-7 warm-up">
          <span className="label-accent">// Catalogue</span>
          <h1 className="broadcast-headline text-5xl lg:text-7xl mt-4 text-[color:var(--nccc-cream)] chromatic">
            Releases
          </h1>
          <p className="mt-6 text-[color:var(--nccc-muted)] max-w-xl">
            Pressed onto the analogue. Each release a node in a wider Northern
            broadcast. Tap a hex to enter the catalogue entry.
          </p>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 label warm-up-2">
          <p>NCCC0001 — DELANEY — &ldquo;I REACH FOR YOU / ARCHETYPES&rdquo; — 7&quot; — 2025</p>
        </div>
      </header>

      {loading ? (
        <p className="label">// loading catalogue...</p>
      ) : items.length === 0 ? (
        <p className="label">// catalogue empty.</p>
      ) : (
        <>
          <div className="honeycomb">
            {items.map((rel) => (
              <HexCard
                key={rel.id}
                testid={`hex-card-release-${rel.id}`}
                imageUrl={resolveUploadUrl(rel.cover_url) || RELEASES_PLACEHOLDER}
                eyebrow={rel.catalogue}
                title={rel.title}
                subtitle={`${rel.artist}${rel.format ? " · " + rel.format : ""}`}
                to={`/releases/${encodeURIComponent(rel.catalogue)}`}
              />
            ))}
          </div>
          <div className="honeycomb-spacer" />
        </>
      )}
    </div>
  );
}
